// extracted by mini-css-extract-plugin
export var leftAlign = "_36-2";
export var popper = "_36-0";
export var subtitle = "_36-1";